import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { EditorState } from 'lexical';
import { faPlus } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faMusic } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import type { Maybe } from '@soundxyz/utils';
import { LexicalInput } from '@components/Lexical/Input';
import { FeedPostModalMainSound } from '@components/modals/FeedPostModal/FeedPostModalMainSound';
import { POST_MAX_CHARACTERS } from '@utils/constants';
import { FeedPostModalMainPlaylist } from './FeedPostModalMainPlaylist';
import type { FeedPostResource } from './types';

export function FeedPostModalMain({
  onEditResource,
  allowEdit,
  resource,
  onChangeLexicalState,
}: {
  onEditResource: () => void;
  allowEdit: boolean;
  onChangeLexicalState: (state: EditorState) => void;
  resource: Maybe<FeedPostResource>;
}) {
  const resourceUI =
    resource != null ? (
      resource.type === 'release' ? (
        <FeedPostModalMainSound
          allowEdit={allowEdit}
          release={resource.release}
          onEditSoundClicked={onEditResource}
        />
      ) : (
        <FeedPostModalMainPlaylist
          playlistId={resource.playlistId}
          onEditPlaylistClicked={onEditResource}
          allowEdit={allowEdit}
        />
      )
    ) : null;

  return (
    <>
      <LexicalInput
        initialMentionData={undefined}
        id={undefined}
        type="multi-line"
        className="mt-1 h-40" // mt-1 to account for outline b/c parent has overflow-x-hidden
        placeholder="What's on your mind?"
        onChange={onChangeLexicalState}
        disabled={false}
        characterCount={{
          maxLength: POST_MAX_CHARACTERS,
          show: true,
        }}
        menuAnchorClassName="z-modalDropdown"
        autoFocus
      />

      {!!resource ? (
        resourceUI
      ) : (
        <button
          onClick={onEditResource}
          className="flex cursor-pointer items-center gap-4 rounded-md border border-base300 p-3 hover:bg-neutral50"
        >
          <div className="flex h-16 w-16 items-center justify-center rounded-md bg-black">
            <FontAwesomeIcon icon={faMusic} className="text-white" />
          </div>
          <div className="flex-1 text-left font-title text-title-xxs font-medium text-neutral700">
            Select sounds or playlists
          </div>
          <FontAwesomeIcon icon={faPlus} size="lg" className="text-base500" />
        </button>
      )}
    </>
  );
}
